import { v4 } from "uuid";

import {
  DiscountUnitType,
  OfferDto,
  OfferTierUnitFieldType,
} from "@intelligems/ig-types";

import {
  recalculateUnitQuantities,
  resetUnitQuantities,
} from "../../formatters/discounts";
import { DISCOUNT_MAX_UNITS } from "../../initials";

export const addTier = <T extends OfferDto>(draft: T): T => {
  if (draft.tiers[draft.tiers.length - 1].maximumUnits === DISCOUNT_MAX_UNITS) {
    draft.tiers[draft.tiers.length - 1].maximumUnits =
      draft.unitType === "unit"
        ? draft.tiers[draft.tiers.length - 1].minimumUnits + 1
        : draft.tiers[draft.tiers.length - 1].minimumUnits + 0.99;
  }

  draft.tiers.push({
    id: v4(),
    minimumUnits:
      draft.unitType === "unit"
        ? draft.tiers[draft.tiers.length - 1].maximumUnits + 1
        : draft.tiers[draft.tiers.length - 1].maximumUnits + 0.01,
    maximumUnits: DISCOUNT_MAX_UNITS,
    unitDiscount: 0,
    discountTitle: null,
    isFreeShipping: draft.tiers[draft.tiers.length - 1].isFreeShipping,
    isGiftWithPurchase: false,
    autoAddGiftWithPurchase: true,
  });

  return draft;
};

export const removeTier = <T extends OfferDto>(
  draft: T,
  tierIndex: number
): T => {
  draft.tiers.splice(tierIndex, 1);
  draft.tiers = recalculateUnitQuantities(draft.unitType, draft.tiers, 0);

  return draft;
};

export const setUnit = <T extends OfferDto>(
  draft: T,
  key: OfferTierUnitFieldType,
  tierIndex: number,
  value: number
): T => {
  draft.tiers[tierIndex][key] = value;

  if (key === "minimumUnits") {
    draft.tiers = recalculateUnitQuantities(
      draft.unitType,
      draft.tiers,
      tierIndex
    );
  }

  return draft;
};

export const toggleDiscountUnitType = <T extends OfferDto>(
  draft: T,
  payload: { value: string }
): T => {
  draft.unitType = payload.value as DiscountUnitType;
  draft.tiers = resetUnitQuantities(draft.tiers);

  return draft;
};
